import { lazy } from 'react';
const FabcIncentive = lazy(() => import('./FabcIncentive'));

const FabcIncentiveRoutes = [
  {
    path: '/fabrication-incentive',
    component: FabcIncentive
  }
];

export default FabcIncentiveRoutes;
